module.exports = __webpack_public_path__ + "img/Unidad21-4.193a2dae.png";